// extracted by mini-css-extract-plugin
module.exports = {"menu":"index_menu__1fX0C","menuItem":"index_menuItem__1azFW","navItem":"index_navItem__3YH6Y","user":"index_user__t1-bF","logout":"index_logout__2tMWS"};